import { ENV } from '@shared/constants/env'
import posthog from 'posthog-js'

const isProduction =
  ENV.SENTRY_ENVIRONMENT === 'production' &&
  (typeof window === 'undefined' || !window.location.hostname.includes('dev'))

export function initPostHog() {
  if (typeof window === 'undefined' || !ENV.POSTHOG_KEY) {
    return
  }

  posthog.init(ENV.POSTHOG_KEY, {
    api_host: ENV.POSTHOG_HOST,
    person_profiles: 'identified_only',
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: isProduction,
  })
}

export function capture(event: string, properties?: Record<string, unknown>) {
  if (isProduction) {
    posthog.capture(event, properties)
  } else {
    console.log('[PostHog]', event, properties ?? '')
  }
}

export { posthog }

// --- PosthogPageView Component ---
import { type ReactNode, useEffect } from 'react'

interface PosthogPageViewProps {
  readonly event: string
  readonly properties?: Record<string, unknown>
  readonly children: ReactNode
}

export function PosthogPageView({ event, properties, children }: PosthogPageViewProps) {
  useEffect(() => {
    capture(event, properties)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event])

  return children
}
